<template>
	<div class="header">
		<div class="container-fluid">
			<!-- Hearer  -->
			<div class="mt-4">
				<div class="card">
					<div class="card-body">
						<div class="row justify-content-between align-items-center">
							<div class="col-12 col-md-9 col-xl-7">
								<!-- Heading -->
								<h2 class="mb-2">Budget Monitoring</h2>
								<div>
									<p class="mb-md-0">&nbsp;</p>
									<p class="mb-md-0">Budget Plan Title: {{ this.activePlan?.title }}</p>
									<p class="mb-md-0">
										Department: {{ this.activePlan?.fund_center?.department_code }} -
										{{ this.activePlan?.fund_center?.department_name }}
									</p>
									<p class="mb-md-0">Year: {{ this.activePlan?.year }}</p>
									<p class="mb-md-0">Version: {{ this.activePlan?.version }}</p>
								</div>
							</div>
							<div class="col-md-auto"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="card">
				<div class="card-body">
					<table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
						<thead>
							<tr>
								<th style="width: 250px"></th>
								<th>Plan</th>
								<th>Actual</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Opex Total</td>
								<td>Rp. {{ convertNumber(summarys.summary?.budget_plan?.opex) }}</td>
								<td>Rp. {{ convertNumber(summarys.summary?.actual_budget?.opex) }}</td>
							</tr>
							<tr>
								<td>Capex Total</td>
								<td>Rp. {{ convertNumber(summarys.summary?.budget_plan?.capex) }}</td>
								<td>Rp. {{ convertNumber(summarys.summary?.actual_budget?.capex) }}</td>
							</tr>
							<tr>
								<td>Total Budget</td>
								<td>Rp. {{ convertNumber(summarys.summary?.budget_plan?.total) }}</td>
								<td>Rp. {{ convertNumber(summarys.summary?.actual_budget?.total) }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="card" v-if="isLoading == true">
				<div class="card-body">
					<b-skeleton-table :rows="7" :columns="3" :table-props="{ bordered: true, striped: true }"> </b-skeleton-table>
				</div>
			</div>
			<div class="card" v-if="isLoading == false">
				<div class="card-body">
					<b-tabs card pills fill>
						<b-tab
							@click="openOpex()"
							:active="activeCapex == false ? true : false"
							:title="`OPEX: RP. ${convertNumber(summarys?.summary?.remaining_budget?.opex)}`"
						>
							<div>
								<div class="row">
									<div class="col-lg-5">
										<div class="form-group">
											<label>Transaction Type</label>
<!--											<v-select
												:clearable="false"
												v-model="TTmodel"
												:options="listTTopex"
												:reduce="(e) => e.id"
												label="name"
												@input="selectTransactionOpex($event, compared.opex)"
											></v-select>-->
                      <v-select
                          :clearable="false"
                          multiple
                          v-model="TTmodel"
                          :options="list_box_opex_monitoring"
                          :reduce="(e) => e.id"
                          label="account"
                          @input="selectTransactionOpex($event, compared.opex)"
                      ></v-select>
										</div>
									</div>
									<div class="col-lg-5">
										<label>Budget Item</label>
										<v-select
											:clearable="false"
											:disabled="TTmodel ? false : true"
											v-model="budgetItemOpex"
											:reduce="(e) => e.gl_code"
											:loading="loadBudget"
											:options="budgetItemList"
											multiple
											label="label"
										>
										</v-select>
									</div>
									<div class="col-lg-2">
										<b-button variant="primary" class="mt-4" @click="selectBudgetItemOpex">Filter</b-button>
										<b-button variant="primary" class="ml-3 mt-4" @click="resetFilter">Reset Filter </b-button>
									</div>
								</div>
							</div>
							<div v-if="filtering == true" class="tableFixHead" style="overflow: auto">
								<table
									class="table table-sm table-bordered p-0 tableFixHead budget-table"
									style="table-layout: fixed; height: auto !important; word-wrap: break-word"
								>
									<thead>
										<tr>
											<th class="text-center" style="width: 125px; z-index: 100 !important; left: 0" rowspan="2">GL</th>
											<th class="text-center" style="width: 350px; z-index: 100" rowspan="2">Budget Item</th>
											<th class="text-center" style="width: 350px" colspan="2">January</th>
											<th class="text-center" style="width: 350px" colspan="2">February</th>
											<th class="text-center" style="width: 350px" colspan="2">March</th>
											<th class="text-center" style="width: 350px" colspan="2">April</th>
											<th class="text-center" style="width: 350px" colspan="2">May</th>
											<th class="text-center" style="width: 350px" colspan="2">June</th>
											<th class="text-center" style="width: 350px" colspan="2">July</th>
											<th class="text-center" style="width: 350px" colspan="2">August</th>
											<th class="text-center" style="width: 350px" colspan="2">September</th>
											<th class="text-center" style="width: 350px" colspan="2">October</th>
											<th class="text-center" style="width: 350px" colspan="2">November</th>
											<th class="text-center" style="width: 350px" colspan="2">December</th>
											<th class="text-center" style="width: 350px" colspan="2">Total</th>
										</tr>
										<tr>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
										</tr>
									</thead>
									<tbody>
										<tr class="opex" v-for="(list, indx) in comparedFilter" :key="indx">
											<td scope="row">{{ list.budget_item.item }}</td>
											<td
												scope="row"
												v-b-popover.hover.top="'Click here for more detail'"
												style="cursor: pointer"
												@click="detailBudget(list)"
											>
												{{ list.budget_item.budget_item }} <span class="float-end fe fe-maximize-2"></span>
											</td>
											<td>Rp. {{ convertNumber(list.summary.jan.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.jan.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.feb.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.feb.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.mar.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.mar.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.apr.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.apr.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.may.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.may.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.jun.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.jun.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.jul.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.jul.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.aug.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.aug.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.sep.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.sep.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.oct.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.oct.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.nov.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.nov.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.dec.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.dec.actual) }}</td>
											<td>Rp. {{ convertNumber(list.summary.total.plan) }}</td>
											<td>Rp. {{ convertNumber(list.summary.total.actual) }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</b-tab>
						<b-tab
							@click="openCapex()"
							:active="activeCapex == true ? true : false"
							:title="`CAPEX: RP. ${convertNumber(summarys?.summary?.remaining_budget?.capex)}`"
						>
							<div class="row mb-3">
								<div class="col-lg-10">
									<label>Budget Item</label>
									<v-select
										:options="list_box_capex_monitoring"
										multiple
										v-model="budgetItemCapex"
										:clearable="false"
										:reduce="(e) => e.gl_code"
										label="account"
									>
									</v-select>
								</div>
								<div class="col-lg-2">
									<b-button variant="primary" class="mt-4" @click="capexFilter">Filter</b-button>
									<b-button variant="primary" class="ml-3 mt-4" @click="resetFilter">Reset Filter </b-button>
								</div>
							</div>
							<div v-if="filteringCapex == true" class="tableFixHead" style="overflow: auto">
								<table
									class="table table-sm table-bordered tableFixHead p-0 budget-table"
									style="table-layout: fixed; height: auto !important; word-wrap: break-word"
								>
									<thead>
										<tr>
											<th style="width: 150px; z-index: 100 !important; left: 0" rowspan="2">GL</th>
											<th class="text-center" style="width: 350px; z-index: 100" rowspan="2">Budget Item</th>
											<th class="text-center" style="width: 350px" rowspan="2">Description</th>
											<th class="text-center" style="width: 350px" colspan="2">January</th>
											<th class="text-center" style="width: 350px" colspan="2">February</th>
											<th class="text-center" style="width: 350px" colspan="2">March</th>
											<th class="text-center" style="width: 350px" colspan="2">April</th>
											<th class="text-center" style="width: 350px" colspan="2">May</th>
											<th class="text-center" style="width: 350px" colspan="2">June</th>
											<th class="text-center" style="width: 350px" colspan="2">July</th>
											<th class="text-center" style="width: 350px" colspan="2">August</th>
											<th class="text-center" style="width: 350px" colspan="2">September</th>
											<th class="text-center" style="width: 350px" colspan="2">October</th>
											<th class="text-center" style="width: 350px" colspan="2">November</th>
											<th class="text-center" style="width: 350px" colspan="2">December</th>
											<th class="text-center" style="width: 350px" colspan="2">Total</th>
										</tr>
										<tr>
											<td style="display: none"></td>
											<td style="display: none"></td>
											<td style="display: none"></td>
											<td style="display: none"></td>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
											<th class="text-center" style="width: 250px">Plan</th>
											<th class="text-center" style="width: 250px">Actual</th>
										</tr>
									</thead>
									<tbody v-for="(item, index) in comparedFilter" :key="index">
										<tr class="opex-first">
											<td class="bg-gray" scope="row">{{ item.capex_gl.gl_code }}</td>
											<td class="bg-gray" scope="row">{{ item.account.account }}</td>
											<td class="bg-gray"></td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.jan.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.jan.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.feb.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.feb.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.mar.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.mar.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.apr.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.apr.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.may.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.may.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.jun.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.jun.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.jul.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.jul.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.aug.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.aug.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.sep.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.sep.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.oct.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.oct.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.nov.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.nov.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.dec.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.dec.actual) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.total.plan) }}</td>
											<td class="bg-gray">Rp. {{ convertNumber(item.summary.total.actual) }}</td>
										</tr>
										<tr v-for="(list, indx) in item.budget" :key="indx">
											<td scope="row"></td>
											<td scope="row">{{ list.name }}</td>
											<td>{{ list.description }}</td>
											<td>Rp. {{ convertNumber(list.jan.plan) }}</td>
											<td>Rp. {{ convertNumber(list.jan.actual) }}</td>
											<td>Rp. {{ convertNumber(list.feb.plan) }}</td>
											<td>Rp. {{ convertNumber(list.feb.actual) }}</td>
											<td>Rp. {{ convertNumber(list.mar.plan) }}</td>
											<td>Rp. {{ convertNumber(list.mar.actual) }}</td>
											<td>Rp. {{ convertNumber(list.apr.plan) }}</td>
											<td>Rp. {{ convertNumber(list.apr.actual) }}</td>
											<td>Rp. {{ convertNumber(list.may.plan) }}</td>
											<td>Rp. {{ convertNumber(list.may.actual) }}</td>
											<td>Rp. {{ convertNumber(list.jun.plan) }}</td>
											<td>Rp. {{ convertNumber(list.jun.actual) }}</td>
											<td>Rp. {{ convertNumber(list.jul.plan) }}</td>
											<td>Rp. {{ convertNumber(list.jul.actual) }}</td>
											<td>Rp. {{ convertNumber(list.aug.plan) }}</td>
											<td>Rp. {{ convertNumber(list.aug.actual) }}</td>
											<td>Rp. {{ convertNumber(list.sep.plan) }}</td>
											<td>Rp. {{ convertNumber(list.sep.actual) }}</td>
											<td>Rp. {{ convertNumber(list.oct.plan) }}</td>
											<td>Rp. {{ convertNumber(list.oct.actual) }}</td>
											<td>Rp. {{ convertNumber(list.nov.plan) }}</td>
											<td>Rp. {{ convertNumber(list.nov.actual) }}</td>
											<td>Rp. {{ convertNumber(list.dec.plan) }}</td>
											<td>Rp. {{ convertNumber(list.dec.actual) }}</td>
											<td>Rp. {{ convertNumber(list.total.plan) }}</td>
											<td>Rp. {{ convertNumber(list.total.actual) }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</b-tab>
					</b-tabs>
				</div>
			</div>
		</div>
		<b-modal size="xl" id="modalBudget" :title="listBudget ? listBudget.budget_item.budget_item : '-'" hide-footer>
			<div style="overflow: auto">
				<table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
					<thead>
						<tr>
							<th style="width: 300px" rowspan="2">NAME</th>
							<th style="width: 300px" rowspan="2">Description</th>
							<th style="width: 350px" colspan="2">January</th>
							<th style="width: 350px" colspan="2">February</th>
							<th style="width: 350px" colspan="2">March</th>
							<th style="width: 350px" colspan="2">April</th>
							<th style="width: 350px" colspan="2">May</th>
							<th style="width: 350px" colspan="2">June</th>
							<th style="width: 350px" colspan="2">July</th>
							<th style="width: 350px" colspan="2">August</th>
							<th style="width: 350px" colspan="2">September</th>
							<th style="width: 350px" colspan="2">October</th>
							<th style="width: 350px" colspan="2">November</th>
							<th style="width: 350px" colspan="2">December</th>
							<th style="width: 350px" colspan="2">Total</th>
						</tr>
						<tr>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
							<th class="text-center" style="width: 250px">Plan</th>
							<th class="text-center" style="width: 250px">Actual</th>
						</tr>
					</thead>
					<!-- {{ listBudget.plan_item_opex_id }} -->
					<tbody>
						<tr v-for="(item, index) in listBudget.budget" :key="index">
							<td>{{ item.name }}</td>
							<td>{{ item.description }}</td>
							<td>Rp. {{ convertNumber(item.jan.plan) }}</td>
							<td>Rp. {{ convertNumber(item.jan.actual) }}</td>
							<td>Rp. {{ convertNumber(item.feb.plan) }}</td>
							<td>Rp. {{ convertNumber(item.feb.actual) }}</td>
							<td>Rp. {{ convertNumber(item.mar.plan) }}</td>
							<td>Rp. {{ convertNumber(item.mar.actual) }}</td>
							<td>Rp. {{ convertNumber(item.apr.plan) }}</td>
							<td>Rp. {{ convertNumber(item.apr.actual) }}</td>
							<td>Rp. {{ convertNumber(item.may.plan) }}</td>
							<td>Rp. {{ convertNumber(item.may.actual) }}</td>
							<td>Rp. {{ convertNumber(item.jun.plan) }}</td>
							<td>Rp. {{ convertNumber(item.jun.actual) }}</td>
							<td>Rp. {{ convertNumber(item.jul.plan) }}</td>
							<td>Rp. {{ convertNumber(item.jul.actual) }}</td>
							<td>Rp. {{ convertNumber(item.aug.plan) }}</td>
							<td>Rp. {{ convertNumber(item.aug.actual) }}</td>
							<td>Rp. {{ convertNumber(item.sep.plan) }}</td>
							<td>Rp. {{ convertNumber(item.sep.actual) }}</td>
							<td>Rp. {{ convertNumber(item.oct.plan) }}</td>
							<td>Rp. {{ convertNumber(item.oct.actual) }}</td>
							<td>Rp. {{ convertNumber(item.nov.plan) }}</td>
							<td>Rp. {{ convertNumber(item.nov.actual) }}</td>
							<td>Rp. {{ convertNumber(item.dec.plan) }}</td>
							<td>Rp. {{ convertNumber(item.dec.actual) }}</td>
							<td>Rp. {{ convertNumber(item.total.plan) }}</td>
							<td>Rp. {{ convertNumber(item.total.actual) }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</b-modal>
	</div>
</template>

<script>
import axiosIns from '@/api/axios';
export default {
	name: 'GentaGendis',
	computed: {
		compared() {
			return this.$store.getters['compared/compared'];
		},
		comparedFilter() {
			return this.$store.getters['compared/comparedFilter'];
		},
    list_box_opex_monitoring() {
      return this.$store.getters['ttAccount/list_box_opex_monitoring'];
    },
    list_box_capex_monitoring() {
      return this.$store.getters['ttAccount/list_box_capex_monitoring'];
    },
	},
	data() {
		return {
      planId: 0,
      fundCenterId: 0,
			activePlan: [],
			listBudget: '',
			id: '',
			TTmodel: [],
			budgetItemOpex: [],
			budgetItemCapex: [],
			budgetItemList: [],
			listTTopex: [],
			listTTcapex: [],
			summarys: {},
			isAdd: true,
			loadBudget: false,
			isLoading: false,
			filteringCapex: false,
			filtering: false,
			activeCapex: false,
			columns: [
				{
					label: 'Role Name',
					field: 'roles_name',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Description',
					field: 'description',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
			],
			rows: [
				{
					roles_name: 'Super Admin',
					description: 'Super Admin has access to all menu',
				},
				{
					roles_name: 'Admin',
					description: 'Admin has role to make budgeting',
				},
				{
					roles_name: 'User',
					description: 'User has role to view budgeting',
				},
			],
		};
	},

	mounted() {
		// this.getList();
		this.getlistPlan();
		//this.getListOPEX();
		//this.getListCAPEX();
		this.getActivePlan();

	},
	methods: {
    getListBoxOpexMonitoring(planId, fundCenterId) {
      if(planId && fundCenterId){
        this.$store.dispatch('ttAccount/GET_LIST_BOX_OPEX_MONITORING', {
          planId: planId,
          fundCenterId: fundCenterId
        })
      }
    },
    getListBoxCapexMonitoring(planId, fundCenterId) {
      if(planId && fundCenterId){
        this.$store.dispatch('ttAccount/GET_LIST_BOX_CAPEX_MONITORING', {
          planId: planId,
          fundCenterId: fundCenterId
        })
      }
    },
		async getActivePlan() {
			try {
				const response = await axiosIns.get('/plan/active-plan');
				this.activePlan = response?.data?.data;
        this.activePlan = response?.data?.data;
        this.planId = this.activePlan?.id || 0
        this.fundCenterId = this.activePlan?.fund_center?.id || 0
        if(this.planId > 0 && this.fundCenterId > 0){
          this.getListBoxOpexMonitoring(this.planId, this.fundCenterId);
          this.getListBoxCapexMonitoring(this.planId, this.fundCenterId);
        }
			} catch (error) {
				console.error('Failed to fetch active plan:', error);
			}
		},
		//action
		selectTransactionOpex(evt, list) {
      this.budgetItemOpex = []
      this.budgetItemList = []
      let budget = this.list_box_opex_monitoring.filter(
          (e) => this.TTmodel.includes(e.id)
      );
      budget?.map((items) => {
            items?.budgetItems?.map((i) =>
                (
                    this.budgetItemList.push({
                      label: i?.budget_item,
                      gl_code: i?.opex_gl[0]?.gl_code,
                    })
                )
            )
          }
      );
		},

		selectBudgetItemOpex() {
      let tempGL = []
      let tempTT = []
      tempTT = [...this.TTmodel]
      let filterTransaction = this.list_box_opex_monitoring.filter(
          (e) => this.TTmodel.includes(e.id)
      );
      let tempTransactionId = [];
      if(this.TTmodel.length > 0){
        this.list_box_opex_monitoring
            .filter(item => this.TTmodel.includes(item.id))
            .forEach(item => {
              if (item.budgetItems?.some(bi => this.budgetItemOpex.includes(bi?.opex_gl?.[0]?.gl_code))) {
                tempTransactionId.push(item.id);
              }
            });
        filterTransaction = filterTransaction.filter(
            (e) => !tempTransactionId.includes(e.id)
        );
        tempGL = [...this.budgetItemOpex]
        filterTransaction.forEach(item => {
          item?.budgetItems?.map((i) => {
                tempGL.push(i?.opex_gl[0]?.gl_code);
              }
          )
        });
      }else{
        tempTT = [...this.TTmodel]
        this.list_box_opex_monitoring.forEach(item => {
          if(item?.budgetItems){
            tempTT.push(item?.id);
          }
        })
      }

			this.activeCapex = false;
			this.filtering = true;
			this.filteringCapex = false;
			this.isLoading = true;
			let bod = {
				type: 'opex',
				account_id: tempTT,
				gl_code: tempGL,
			};
			this.$store.dispatch('compared/GET_BUDGET_COMPARE_FILTER', bod).then((resp) => {
				this.isLoading = false;
			});
		},

		capexFilter() {
			this.activeCapex = true;
			this.filteringCapex = true;
			this.filtering = false;
			this.isLoading = true;
			let bod = {
				type: 'capex',
				gl_code: this.budgetItemCapex,
			};
			this.$store.dispatch('compared/GET_BUDGET_COMPARE_FILTER', bod).then((resp) => {
				this.isLoading = false;
			});
		},

		resetFilter() {
			this.filtering = false;
			this.filteringCapex = false;
			(this.TTmodel = ''), (this.budgetItemOpex = []), (this.budgetItemCapex = []);
		},
		openOpex() {
			this.activeCapex = false;
			this.filtering = false;
			//this.comparedFilter = [];
			this.filteringCapex = false;
			(this.TTmodel = ''), (this.budgetItemOpex = []), (this.budgetItemCapex = []);
		},
		openCapex() {
			this.activeCapex = true;
			this.filtering = false;
			this.filteringCapex = false;
			//this.comparedFilter = [];
			(this.TTmodel = ''), (this.budgetItemOpex = []), (this.budgetItemCapex = []);
		},

		detailBudget(item) {
			this.listBudget = item;
			setTimeout(() => {
				this.$bvModal.show('modalBudget');
			}, 1000);
		},

		getList() {
			this.$store.dispatch('compared/GET_BUDGET_COMPARE');
		},

		convertNumber(dat) {
			if (dat) {
				return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
			} else {
				return 0;
			}
		},

		getListOPEX() {
			axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/opex`).then((resp) => {
				this.listTTopex = resp.data.data;
			});
		},
		getlistPlan() {
			axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring`).then((resp) => {
				this.summarys = resp.data.data;
			});
		},
		getListCAPEX() {
			axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/capex`).then((resp) => {
				let datas = resp.data.data.map((e) => {
					return {
						label: `${e.account_id.account}`,
						gl: e.gl_code,
					};
				});
				this.listTTcapex = datas;
			});
		},
	},
};
</script>
<style>
.tableFixHead {
	overflow-y: scroll;
	height: 75vh;
}

.tableFixHead thead {
	position: sticky;
	top: 0px;
	z-index: 2;
}

.tableFixHead thead td {
	position: sticky;
	top: 0px;
	left: 0;
	z-index: 4;
	background-color: #f9fbfd;
	color: #95aac9;
}

.tableFixHead tbody th {
	position: sticky;
	left: 0;
	background-color: white;
	z-index: 0;
}

table.budget-table {
	border-collapse: collapse;
	width: 100%;
}

.budget-table th,
.budget-table td {
	padding: 8px 16px;
}

.budget-table th {
	background: #eee;
}

table.budget-table {
	/* margin: 1em 0; */
	border-collapse: collapse;
	border: 0.1em solid #d6d6d6;
}

.budget-table th,
.budget-table td {
	padding: 0.25em 0.5em 0.25em 1em;
	text-align: center;
	text-indent: -0.5em;
}

.budget-table th {
	vertical-align: bottom;
	background-color: #666;
	color: #fff;
}

.budget-table tr:nth-child(even) td[scope='row'] {
	background-color: #f2f2f2;
}

.budget-table tr:nth-child(odd) td[scope='row'] {
	background-color: #fff;
}

.budget-table tr:nth-child(even) {
	background-color: rgba(0, 0, 0, 0.05);
}

.budget-table tr:nth-child(odd) {
	background-color: rgba(255, 255, 255, 0.05);
}

/* th:nth-of-type(3),
td:nth-of-type(3) {
  text-align: right;
}

/* Fixed Headers */

.budget-table th {
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	z-index: 2;
}

.budget-table td[scope='row'] {
	position: -webkit-sticky;
	position: sticky;
	left: 0;
	z-index: 1;
}

.budget-table td:nth-child(2),
.budget-table th:nth-child(2) {
	left: 125px;
}

.budget-table td:nth-child(3),
.budget-table th:nth-child(3) {
	left: 225px;
}

.budget-table th[scope='colss'] {
	position: -webkit-sticky;
	position: sticky;
	left: 0;
	z-index: 91;
}

.budget-table td[scope='row'] {
	vertical-align: top;
	color: inherit;
	background-color: inherit;
	background: linear-gradient(
		90deg,
		transparent 0%,
		transparent calc(100% - 0.05em),
		#d6d6d6 calc(100% - 0.05em),
		#d6d6d6 100%
	);
}

table.budget-table:nth-of-type(2) th:not([scope='row']):first-child {
	left: 0;
	z-index: 3;
	background: linear-gradient(90deg, #666 0%, #666 calc(100% - 0.05em), #ccc calc(100% - 0.05em), #ccc 100%);
}

/* table.budget-table th, table.budget-table td {
    padding: 1px;
}  */
</style>
